import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebTestingService {
  private formatTrigger = new Subject<void>();
  formatTrigger$ = this.formatTrigger.asObservable();

  triggerFormatDetails() {
    this.formatTrigger.next();
  }
}
